export const ORGANIZATION_OWNER = "organization-admin";
export const ORGANIZATION_MANAGER = "organization-manager";
export const FINANCIAL = "organization-financial";
export const DEVELOPER = "organization-developer";
export const LEGAL = "organization-le";

export const MEMBER_ACTIVE = "active";
export const MEMBER_PENDING_INVITATION = "pending_invitation";

export const ERROR_CREATE_MEMBERSHIP = "createMembership";
export const ERROR_RESEND_INVITATION = "errorResendInvitation";
export const SUCCESS_RESEND_INVITATION = "successResendInvitation";

export const CONTENT_TYPE_APPLICATION = "node--application";

export const ROLE_DEFINITIONS = [
  {
    id: ORGANIZATION_OWNER,
    name: "Organization Owner",
    description:
      "Manages the organization: members and their roles, documents, and all applications (create, edit, delete, reset secrets).",
  },
  {
    id: FINANCIAL,
    name: "Financial",
    description:
      "Can view the organization's applications and their API consumption.",
  },
  {
    id: DEVELOPER,
    name: "Developer",
    description:
      "Can create, edit and reset the secrets of the organization's applications, and upload documents.",
  },
  {
    id: LEGAL,
    name: "Legal",
    description:
      "Can view the organization's applications and upload documents.",
  },
];

export const MEMBER_DEFINITIONS = [
  {
    id: MEMBER_ACTIVE,
    name: "Active",
  },
  {
    id: MEMBER_PENDING_INVITATION,
    name: "Pending Invitation",
  },
];

// Map API role names to expected role IDs
export const ROLE_NAME_TO_ID_MAP = {
  "Organization Owner": ORGANIZATION_OWNER,
  "Organization Admin": ORGANIZATION_OWNER,
  Owner: ORGANIZATION_OWNER,
  Admin: ORGANIZATION_OWNER,
  "Organization Manager": ORGANIZATION_MANAGER,
  Manager: ORGANIZATION_MANAGER,
  Financial: FINANCIAL,
  Finance: FINANCIAL,
  Developer: DEVELOPER,
  Development: DEVELOPER,
  Legal: LEGAL,
  LE: LEGAL,
};

// Helper function to convert role name to ID
export const getRoleIdFromName = (roleName) => {
  if (!roleName) return null;

  // Check if it's already a valid role ID
  const validIds = [
    ORGANIZATION_OWNER,
    ORGANIZATION_MANAGER,
    FINANCIAL,
    DEVELOPER,
    LEGAL,
  ];
  if (validIds.includes(roleName)) {
    return roleName;
  }

  // Try to map from name to ID
  return ROLE_NAME_TO_ID_MAP[roleName] || roleName;
};

// What each organization role may do. The permission strings are the Drupal-era names still
// used by the components (see constants/organizationPermissions.js); the Core has no
// equivalent, so this map is the single place that decides who sees which control.
const VIEW_PERMISSIONS = [
  "view group",
  "view group_membership content",
  "view group_node:application content",
  "view group_node:application entity",
  "view unpublished group_node:application entity",
  "access content overview",
  "access group_node overview",
];
const APPLICATION_PERMISSIONS = [
  "create group_node:application content",
  "create group_node:application entity",
  "update any group_node:application content",
  "update any group_node:application entity",
  "update own group_node:application content",
  "update own group_node:application entity",
  "delete any group_node:application content",
  "delete any group_node:application entity",
  "delete own group_node:application content",
  "delete own group_node:application entity",
];
const MANAGE_PERMISSIONS = [
  "administer members",
  "edit group",
  "update own group_membership content",
];

export const ROLE_PERMISSIONS = {
  [ORGANIZATION_OWNER]: [
    ...VIEW_PERMISSIONS,
    ...APPLICATION_PERMISSIONS,
    ...MANAGE_PERMISSIONS,
    "administer group",
    "delete group",
  ],
  [ORGANIZATION_MANAGER]: [
    ...VIEW_PERMISSIONS,
    ...APPLICATION_PERMISSIONS,
    ...MANAGE_PERMISSIONS,
  ],
  [DEVELOPER]: [...VIEW_PERMISSIONS, ...APPLICATION_PERMISSIONS],
  [FINANCIAL]: VIEW_PERMISSIONS,
  [LEGAL]: VIEW_PERMISSIONS,
};

export const rolesHavePermission = (roles, permission) =>
  (roles || []).some((role) =>
    (ROLE_PERMISSIONS[role] || []).includes(permission)
  );
